const noSpaces = (value: string) => !/\s/.test(value);
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const argentinePhoneRegex = /^(?:\+?54)?(?:0)?(?:9)?(?:11|[2368]\d)(?:\d{7}|\d{8})$/;

export { noSpaces, emailRegex, argentinePhoneRegex };
